"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by mariam.melkonyan on 5/3/17.
 */
class ChartControlOptions {
    constructor(options) {
        /**
         * Defines if the legend should be visible
         */
        this._isLegendVisible = true;
        /**
         * Defines if the data labels should be showed
         */
        this._isDataLabelsShowed = false;
        if (options.chartPalette === null || options.chartPalette === undefined || options.length === 0) {
            throw new Error("Chart Palette is required and it must have at least one value.");
        }
        if (options.chartType === null || options.chartType === undefined) {
            throw new Error("Chart Type is required.");
        }
        this._chartType = options.chartType;
        this._chartPalette = options.chartPalette;
        options.isLegendVisible !== undefined && (this._isLegendVisible = options.isLegendVisible);
        this._isRTL = options.isRTL || false;
        options.isDataLabelsShowed !== undefined && (this._isDataLabelsShowed = options.isDataLabelsShowed);
    }
    set isLegendVisible(isLegendVisible) {
        this._isLegendVisible = isLegendVisible;
    }
    get isLegendVisible() {
        return this._isLegendVisible;
    }
    set chartPalette(chartPalette) {
        this._chartPalette = chartPalette;
    }
    get chartPalette() {
        return this._chartPalette;
    }
    set chartType(chartType) {
        this._chartType = chartType;
    }
    get chartType() {
        return this._chartType;
    }
    get isRTL() {
        return this._isRTL;
    }
    set isRTL(value) {
        this._isRTL = value;
    }
    get isDataLabelsShowed() {
        return this._isDataLabelsShowed;
    }
    set isDataLabelsShowed(value) {
        this._isDataLabelsShowed = value;
    }
}
exports.ChartControlOptions = ChartControlOptions;
//# sourceMappingURL=chart-control-options.model.js.map